<script lang="ts">
    import { onMount } from "svelte";
    import "../../../node_modules/maplibre-gl/dist/maplibre-gl.css";
    import type { TestManager } from "./TestManager";
    import Routing from "./routing/Routing.svelte";
    import ToolBox from "../../map/controls/toolbox/ToolBox.svelte";
    import NavigationTool from "../../map/controls/navigation/NavigationTool.svelte";
    import MaxSpeedTool from "../../map/controls/maxspeeds/MaxSpeedTool.svelte";
    import LayersTool from "../../map/controls/base-layers/LayersTool.svelte";
    import LayersToolBox from "../../map/controls/base-layers/LayersToolBox.svelte";
    import CommitsTool from "../../map/controls/commits/CommitsTool.svelte";
    import CommitsToolBox from "../../map/controls/commits/CommitsToolBox.svelte";
    import ScenarioShareButton from "../../map/controls/sharing/ScenarioShareButton.svelte";
    import ScenarioShareToolBox from "../../map/controls/sharing/ScenarioShareToolBox.svelte";
    import MapillaryImageViewer from "../../map/data/mapillary/viewer/MapillaryImageViewer.svelte";
    import CompareToolBox from "../../map/comparison/CompareToolBox.svelte";
    import CompareButton from "../../map/comparison/CompareButton.svelte";
    import TripsScenario from "../../map/controls/layers/trips/TripsScenario.svelte";

    export let manager: TestManager;
    let tripsLayerManagers = manager.getTripsScenarioManagersStore();

    let mapContainer: HTMLDivElement;

    onMount(async () => {
        await manager.initialize(mapContainer);
    });
</script>

<svelte:head>
    <title>ANYWAYS</title>
</svelte:head>

<div class="container g-0 h-100 px-0">
    <div class="row g-0 h-100">
        <div class="col-3 h-100 p-2 tool-width">
                <Routing manager={manager.getRoutingManger()} />
                {#each $tripsLayerManagers as tripsLayerManager}
                    <TripsScenario manager={tripsLayerManager} />
                {/each}
        </div>
        <div class="col-9 h-100 map-width">
            <div class="map h-100 g-0" bind:this={mapContainer}>
                <ToolBox manager={manager.getNavigationToolBoxManager()}>
                    <NavigationTool manager={manager.getNavigationToolManager()} />
                </ToolBox>
                <ToolBox manager={manager.getToolBoxManager()}>
                    <LayersTool
                        manager={manager.getToolBoxManager()} />
                    <MaxSpeedTool manager={manager.getMaxSpeedToolManager()} />
                    <CommitsTool 
                        manager={manager.getToolBoxManager()} />
                    <ScenarioShareButton manager={manager.getToolBoxManager()} />
                    <CompareButton manager={manager.getToolBoxManager()}  />
                </ToolBox>
                <LayersToolBox manager={manager.getLayersToolBoxManager()}/>
                <CommitsToolBox manager={manager.getCommitsToolBoxManager()} />
                <ScenarioShareToolBox manager={manager.getScenarioShareToolBoxManager()} />
                <CompareToolBox manager={manager.getCompareToolBoxManager()} />
                <MapillaryImageViewer manager={manager.getMapillaryMapManager()}/>
            </div>
        </div>
    </div>
</div>

<style>
    .tool-width {
        width: 320px;
        overflow-y: scroll;
    }
    .map-width {
        width: calc(100% - 320px);
        max-height: 100%;
    }
</style>
